export enum AppType {
    Host = 'host',
    Remote = 'remote',
}

export enum Language {
    JavaScript = 'js',
    TypeScript = 'ts',
}
